import m from "mithril";
import infinite from "mithril-infinite";
import tools from "../tools/tools";
import merge from "../tools/merge";

export default (_renderitem, _getpage, _pagesize, _prefetchpages, classname) => {
	let pages = {};
	let minmaxcache = {};
	let prefetchpages = _prefetchpages || 3;
	let totalrows = 0;
	let totalpages = 0;
	let search = undefined;
	let tempsearch = undefined;
	let page1Done = false;
	let firstPageRequest = undefined;
	const debounce = Debounce(processsearch, 800);

	function processsearch() {
		if (search != tempsearch) {
			search = tempsearch;
			reset();
		}
		GetPageFromBackend(1).then((_) => {
			m.redraw();
		});
	}

	function reset() {
		pages = {};
		minmaxcache = {};
		page1Done = false;
		firstPageRequest = undefined;
	}

	function setsearch(t) {
		tempsearch = t;
		debounce();
	}
	async function GetPageFromBackend(pagenum) {
		let promise = new Promise((resolve) => {
			if (_getpage) {
				_getpage(
					pagenum,
					pagenum == 1 ? _pagesize * (prefetchpages + 1) : _pagesize,
					search,
					({rows = [], rowscount = 0, idcol = "id"}) => {
						if (pagenum == 1) {
							for (let index = 0; index < prefetchpages + 1; index++) {
								pages[index + 1] = rows.slice(index * _pagesize, (index + 1) * _pagesize);
							}
							page1Done = true;
							if (rowscount) {
								totalrows = rowscount || _pagesize;
								totalpages = Math.ceil(totalrows / _pagesize);
							}
						} else pages[pagenum] = rows;

						// console.log(pages);

						minmaxcache[pagenum] = {};
						minmaxcache[pagenum].min = Math.min(...rows.map((t) => t[idcol]));
						minmaxcache[pagenum].max = Math.max(...rows.map((t) => t[idcol]));

						resolve();
					}
				);
			} else {
				resolve();
			}
		});
		if (pagenum == 1) firstPageRequest = promise;
		await promise;
		return null;
	}
	async function getpagedata(pagenum) {
		// console.log("request for ", pagenum);

		if (pages[pagenum]) {
			// console.log("result for page num", pagenum);
			return pages[pagenum];
		} else {
			if (page1Done || pagenum == 1) {
				await GetPageFromBackend(pagenum);
			}

			if (firstPageRequest) {
				// console.log("waitin for page", pagenum);
				await firstPageRequest;
				firstPageRequest = undefined;
			}

			if (pages[pagenum]) {
			} else {
				await GetPageFromBackend(pagenum);
			}
			if (pages[pagenum]) return pages[pagenum];
			else return [];
		}
	}
	function createpagekey(pagenum) {
		return `${pagenum}-${search}`;
	}

	return {
		reset: () => {
			reset();
		},
		updatedata: (keycol, keyval, mergedata) => {
			// console.log("update request");
			Object.keys(pages).forEach((pk) => {
				// console.log("checking page no", pk);
				pages[pk].forEach((d, i) => {
					// console.log("checking data", {d, i, keycol, keyval});
					if (d[keycol] == keyval) {
						// console.log("found a record. updating", pages[pk][i]);
						// console.log(merge);
						pages[pk][i] = merge(d, mergedata);
						// console.log("updated", pages[pk][i]);
					}
				});
			});
			m.redraw();
		},
		minmax: () => {
			return minmaxcache;
		},
		setsearch: (s) => {
			setsearch(s);
		},
		component: () => {
			return {
				oninit: (v) => {
					// console.log("initiating infinite");
					getpagedata(1).then((_) => {
						m.redraw();
					});
				},
				view: (v) => {
					if (page1Done)
						return m(infinite, {
							item: _renderitem,
							maxPages: totalpages || 1,
							preloadPages: _prefetchpages,
							pageData: getpagedata,
							pageKey: createpagekey,
						});
					else return tools.Spinner("Loading...");
				},
			};
		},
	};
};

function Debounce(func, wait = 100) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func.apply(this, args);
		}, wait);
	};
}

// let ilist = infinite(
// 	(data, options, index) => {
// 		return m(".item", `${item} - ${index}`);
// 	},
// 	async (pagenum, pagesize, search) => {
// 		console.log("getpage", {pagenum, pagesize, search});
// 		const r = await pf.APIAction("", {
// 			lastid: ilist.minmax()[pagenum - 1]?.max || "",
// 			pagenum,
// 			pagesize,
// 		});
// 		return {rows: r.data, rowscount: r.rowscount, idcol: "id"};
// 	},
// 	10,
// 	3
// );
